export default __webpack_public_path__ + "static/media/courseLanding-aiSecurity.31c1e1da.png";